import React from 'react';
import { Badge } from '@/components/ui/badge';
import { X } from 'lucide-react';

export function MarksCard({ markColor, setMarkColor, markSize, setMarkSize, markLabel, setMarkLabel, markDetail, setMarkDetail }) {
  const dropZone = (label, value, setter, acceptHint) => (
    <div className="flex items-center gap-1.5">
      <span className="text-[8px] text-muted-foreground w-10">{label}</span>
      <div className="flex-1 rounded-md border-2 border-dashed border-border/30 min-h-[24px] px-1.5 py-0.5 text-[9px]"
        onDragOver={e => { e.preventDefault(); e.currentTarget.classList.add('border-primary/50'); }}
        onDragLeave={e => e.currentTarget.classList.remove('border-primary/50')}
        onDrop={e => { e.preventDefault(); e.currentTarget.classList.remove('border-primary/50'); try { const d = JSON.parse(e.dataTransfer.getData('application/json')); setter(d.name); } catch {} }}>
        {value ? (
          <Badge className={`text-[8px] ${label === 'Color' ? 'bg-emerald-500/15 text-emerald-400 border-emerald-500/20' : label === 'Size' ? 'bg-primary/15 text-primary border-primary/20' : 'bg-muted/50 text-muted-foreground'} cursor-pointer`} onClick={() => setter('')}>
            {value} <X className="w-2 h-2 ml-0.5" />
          </Badge>
        ) : <span className="text-muted-foreground/30">{acceptHint}</span>}
      </div>
    </div>
  );

  return (
    <div className="p-3 border-b border-border/30">
      <p className="text-[9px] text-muted-foreground uppercase tracking-wider font-semibold mb-1.5">Marks</p>
      <div className="space-y-1">
        {dropZone('Color', markColor, setMarkColor, 'Drag dimension')}
        {dropZone('Size', markSize, setMarkSize, 'Drag measure')}
        {dropZone('Label', markLabel, setMarkLabel, 'Drag any field')}
        {dropZone('Detail', markDetail, setMarkDetail, 'Drag dimension')}
      </div>
    </div>
  );
}
